/**
 * Formats a variable-length list.
 *
 * For example: ["milk", "eggs", "cheese"] => "milk, eggs, and cheese"
 *
 * In order to format a list, you must define four translations:
 *     listStart: "{0}, {1}"
 *     listMiddle: "{0}, {1}"
 *     listEnd: "{0}, and {1}"
 *     twoItemList: "{0} and {1}"
 *
 * These four translations can be combined to format a list of any length.
 * This approach allows translators to customize the format per-language.
 * If different messages need to be displayed in different formats, you can create multiple ListFormats backed by different translations.
 */
var Substitution = require('./Substitution');

module.exports = {
    format: function(listFormat, items) {
        if (items.length === 0) {
            return '';
        }
        if (items.length === 1) {
            return items[0];
        }
        if (items.length === 2) {
            return Substitution.substitution(listFormat.twoItemList, items);
        }

        var current = Substitution.substitution(listFormat.listStart, [items[0], items[1]]);
        for (var index = 2; index < items.length - 1; index++) {
            current = Substitution.splitSubstitution(listFormat.listMiddle, [
                current,
                items[index]
            ]).join('');
        }

        return Substitution.splitSubstitution(listFormat.listEnd, [
            current,
            items[items.length - 1]
        ]).join('');
    },
    getPattern: function(listFormat, listLength) {
        var items = [];
        for (var i = 0; i < listLength; i++) {
            items.push('{' + i + '}');
        }

        return this.format(listFormat, items);
    }
};
